import { api } from '@/common/api';

const initialTasks = {
    all: null,
    overdue: null,
    today: null,
    tomorrow: null,
    timeless: null
};
const initialIncomes = {
    cashless: {
        new: null,
        onCheck: null,
        toFix: null
    }
};

const store = {
    namespaced: true,
    state() {
        return {
            tasks: { ...initialTasks },
            leads: null,
            incomes: { ...initialIncomes }
        };
    },
    mutations: {
        setTasksMetrics(state, metrics) {
            state.tasks = metrics.tasks ? metrics.tasks : { ...initialTasks };
        },
        setLeadsMetrics(state, metrics) {
            state.leads = metrics.leads ? metrics.leads : null;
        },
        setIncomesMetrics(state, metrics) {
            state.incomes = metrics.incomes ? metrics.incomes : { ...initialIncomes };
        },
        setIncomesNewToFixCashLessMetrics(state, metric) {
            state.incomes.cashless.new = metric.incomes.cashless.new;
            state.incomes.cashless.toFix = metric.incomes.cashless.toFix;
        },
        setIncomesOnCheckCashLessMetrics(state, metric) {
            state.incomes.cashless.onCheck = metric.incomes.cashless.onCheck;
        }
    },
    actions: {
        async getMetrics({ state, commit }) {
            try {
                const response = await api.get('/metric');
                commit('setTasksMetrics', response.data.data);
                commit('setLeadsMetrics', response.data.data);
                commit('setIncomesMetrics', response.data.data);
            } catch (error) {
                console.log(error);
                throw new Error(error);
            }
        }
    }
};

export default store;
